import {EventEmitter} from "@angular/core";

export class HeaderCustMenuBase {
    id: number;
    name: string;
    label: string;
    desc: string;
    menuorder: number;
    menuitem: string;

    notifyParent: EventEmitter<any> = new EventEmitter();

    public Clear() {
        this.id = 0;
        this.name = '';
        this.label = '';
        this.desc = '';
        this.menuorder = 0;
        this.menuitem = '';
    }

    public load(adata){
        this.id = adata.id;
        this.name = adata.name;
        this.label = adata.label;
        this.desc = adata.description;
        this.menuorder = adata.menuorder;
        this.menuitem = adata.menuitem;
        this.notifyParent.emit();
    }    
}
